const safeParse = (value)=>{
    try{
        return JSON.parse(value);
    }catch{
        return undefined;
    }
};

export const loadFromStorage = (key, validator)=>{
    try{
        const raw = localStorage.getItem(key);
        if(!raw) return undefined;

        const parsed = safeParse(raw);
        if(!raw) return undefined;

        if(validator && !validator(parsed))return undefined;

        return parsed;
    }catch{
        return undefined;
    }
};

export const saveToStorage = (key,value)=>{
    try{
        localStorage.setItem(key, JSON.stringify(value));
    }catch{
        // will add here later for silent fail probaly not silent
     }
};